<template>
  <div class="py-0 rounded-lg __basic-table border-brand-sand border-2">
    <table
      v-if="columns && columns.length"
      class="min-w-full divide-y divide-brand-sand basic-table-striped"
      :class="[rowSelectable ? 'row-selectable' : '']"
    >
      <thead class="bg-brand-sand">
        <tr class="px-4">
          <th
            v-for="column in columns"
            :key="column.prop"
            class="text-xs font-bold text-brand-brown"
            :class="[compressed ? 'py-3 px-1' : 'px-6 py-3', column.align ? `text-${column.align}` : '']"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="d in mappedData"
          :key="d[idProp]"
          @click="$emit('row-click', d)"
          :class="[highlightedRow && d[idProp] === highlightedRow ? 'highlighted-tr' : '']"
        >
          <td
            v-for="column in columns"
            :key="column.prop"
            @click="$emit('cell-click', d, column.prop)"
            class="whitespace-nowrap font-medium text-brand-brown"
            :class="[
              compressed ? (zeroPadding ? 'text-xs px-1 py-1.5' : 'text-xs py-3 px-2') : 'text-sm px-6 py-4',
              column.align ? `text-${column.align}` : '',
            ]"
          >
            <span v-if="column.formatter" v-html="column.formatter(d[column.prop], d)"></span>
            <span v-else>{{ d[column.prop] }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BasicTable',
  data() {
    return {};
  },
  props: {
    compressed: {
      type: Boolean,
      required: false,
    },
    zeroPadding: {
      type: Boolean,
      required: false,
    },
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    idProp: {
      type: String,
      required: true,
    },
    highlightedRow: {
      type: String,
    },
    rowSelectable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // data after value accessor has been applied to all columns/rows
    mappedData() {
      return this.data.map((row) => {
        const mapped = this.columns.reduce((acc, column) => {
          acc[column.prop] = column.valueAccessor ? column.valueAccessor(row) : row[column.prop];
          return acc;
        }, {});
        return {
          ...row,
          ...mapped,
        };
      });
    },
  },
};
</script>

<style lang="scss">
.__basic-table {
  table {
    margin-top: 0 !important;
    // margin-bottom: 3px !important;
  }
  table.basic-table-striped {
    tr:nth-child(even) {
      background-color: #fcf7f399;
    }
    tr:nth-child(odd) {
      @apply bg-white;
    }
    thead tr:first-child {
      @apply bg-brand-light-sand;
      font-weight: bold;
    }
  }
  table.row-selectable {
    tr:hover {
      @apply transition-all;
      @apply bg-brand-light-sand;
      @apply cursor-pointer;
    }
  }
  tr.highlighted-tr {
    background-color: #f3e4d4 !important;
  }
  table td:first-child {
    @apply pl-4;
  }
  table td:last-child {
    // @apply pr-4;
  }
  table th:first-child {
    @apply pl-4;
    @apply text-left;
  }
  table th:last-child {
    // @apply pr-4;
  }
}
</style>
